import { LinkingOptions, getStateFromPath } from '@react-navigation/native';
import * as Linking from "expo-linking";
import store from '../store';
import { auth_getNotificationById, auth_loginShortToken, auth_logout, auth_setNotification } from '../store/actionsv1/auth';
import { player_getReferralByCode } from '../store/actionsv1/player';
import { V1_LOGIN, V1_LOGOUT, V1_UPDATE_INITIAL_URL } from '../store/actionsv1/types';
import { segEventTrack } from '../utils/analytics/segment';
import { market_getOrderByIdForDeepLink, market_setDraftOrder } from '../store/actionsv1/markets';
import moment from 'moment';
import { autoLoginCheck } from '../screensV1/Auth/helpers/security';
import { socket_authenticate } from '../store/actionsv1/socket';


const prefix = Linking.makeUrl("/");
export const getInitialURL = async() => {
    const initial_url = await Linking.getInitialURL()
    return initial_url
}


const launchOrder = async(order_id:string) => {
  let order = await market_getOrderByIdForDeepLink(order_id);
  if(!order){ return }
  store.dispatch(market_setDraftOrder({
        ...order, 
        open_amt: 10,
        influencer_id:undefined,
        influence_type: undefined,
        tip_pct:undefined,
        tip_type:undefined,
        expire_datetime: moment().add(1, 'minutes'), 
        order_type: 'limit', 
        buy_sell_ind: 'buy' 
      }
   ))
}

const tryLogin = async(token:string) => {
  const is_authenticated = store.getState().auth.isAuthenticated
  if(is_authenticated){ store.dispatch({ type:V1_LOGOUT }) }
  try {
    await store.dispatch(auth_loginShortToken(token))
  } catch (e) {
    console.log(e)
  }
}

let init_routed = false
const handleQueryParam = (path:string):string => {
  const parsedPath2 = path.split(/[?&]/)
  let newPath = path
  if(init_routed){ return newPath }
  init_routed = true
  parsedPath2.map(p => {
    let vars = p.split('=')
    if(vars.length !== 2){ return }
    const queryVariable = vars[0]
    const queryValue = vars[1]
    switch(queryVariable){
      case 'refer':
        console.log('GETTING REFERRAL!!')
        store.dispatch(player_getReferralByCode(queryValue)); 
        segEventTrack({ event: 'Referred User', properties : { referral_code: queryValue }});
        break
      case 'order':
        launchOrder(queryValue)
        break
      case 'notify':
        store.dispatch(auth_setNotification(queryValue))
        break
      case 'token':
        tryLogin(queryValue)
        break
      default: break;
    }
  })
  newPath = parsedPath2[0]
  if(!store.getState().auth.isAuthenticated){
    store.dispatch({ type:V1_UPDATE_INITIAL_URL, initial_url:newPath })  
  }
  return newPath
}

export const linking: LinkingOptions = {
  prefixes: [prefix],
  getStateFromPath: (path, options) => {
    let newPath = handleQueryParam(path)
    return getStateFromPath(newPath, options);
  },
  config : {
    screens: {
      NoAuthStack: {
        path: 'view',
        initialRouteName: 'Events',
        screens: {
          Events: {
            path: 'markets/:side?',
            parse: {
              side: side => side
            }
          },
          ActivityFeed: {
            path: 'activity'
          }
        }
      },
      AuthStack: {
        path: 'account',
        initialRouteName: 'Authenticate',
        screens: {
          
          Authenticate :{
            path: 'authenticate',

          },
          Premium :{
            path: 'premium'
          }
        }
      },
      PollStack : {
        path: 'polls',
        initialRouteName: 'Poll',
        screens: {
          Poll : {
            path: 'respond/:poll_campaign_id',
            parse: {
              poll_campaign_id: (poll_campaign_id:string) => poll_campaign_id
            }
          },
          PollReview : {
            path: 'review/:poll_campaign_id',
            parse: {
              poll_campaign_id: (poll_campaign_id:string) => poll_campaign_id
            }
          }
        }
      },
      Auth: {
        path:'',
        initialRouteName: 'EventStack',
        screens: {
          HomeStack : {
            path: 'home',
            initialRouteName: 'Dashboard',
            screens: {
              Dashboard: {
                path: 'dashboard'
              },
              InviteFriends: {
                path: 'invite'
              },
              ManagePolls : {
                path: 'polls/manage'
              },
              Notification: {
                path: 'notification'
              },
              ActivityRebates: {
                path: 'rebates'
              },
              ActivityRebate: {
                path: 'rebates/rebate/:player_commission_rebate_id',
                parse: {
                  player_commission_rebate_id: player_commission_rebate_id => player_commission_rebate_id
                }
              },
              PlayerCoupons: {
                path: 'coupons'
              },
              PlayerCoupon: {
                path: 'coupons/coupon/:player_coupon_id',
                parse: {
                  player_coupon_id: player_coupon_id => player_coupon_id
                }
              },
              MarketPerformance: {
                path: 'marketPerformance'
              },
              OverallMetrics: {
                path: 'metrics'
              },
              ActivityMetrics: {
                path: 'metrics/activity'
              },
              MyAccount: {
                path: 'myAccount'
              },
              ChangeAccount: {
                path: 'changeAccount'
              },
              ChallengeHome: {
                path: 'challenge'
              },
              GuideSelect : {
                path: 'help'
              },
              BeScore: {
                path: 'bescore/:market_type',
                parse:{
                  market_type: market_type => market_type,
                }
              },
              BalanceRecon: {
                path:'/balanceReconciliation'
              },
              ACH : {
                path: '/wallet'
              },
              ACHAccount: {
                path: '/wallet/account/:account_id',
                parse: {
                  account_id: account_id => account_id
                }
              },
              ACHLimit: {
                path:'/wallet/account/limits/:account_id',
                parse: {
                  account_id: account_id => account_id
                }
              },
              ACHDelete: {
                path: '/wallet/account/delete/:account_id',
                parse: {
                  account_id: account_id => account_id
                }
              },
              ACHPay: {
                path: '/wallet/account/:account_id/:action',
                parse :{
                  account_id: account_id => account_id,
                  action: action => action
                }
              }
            },
          },
          EventStack : {
            path: 'markets',
            initialRouteName: 'Events',
            screens: {
              Events : {
                path: 'events'
              },
              Tournament: {
                path: 'tournament/:tournament_id',
                parse: {
                  tournament_id: tournament_id => tournament_id
                }
              },
              Tournament2: {
                path: 'details/tournament/:tournament_id/:league_id',
                parse: {
                  tournament_id: tournament_id => tournament_id,
                  league_id: league_id => league_id

                }
              },
              Market : {
                path: 'market/:event_type/:event_id/:market_id/:participant_id?',
                parse: {
                    event_type: event_type => event_type,
                    event_id: event_id => event_id,
                    market_id: market_id => market_id,
                    participant_id: participant_id => participant_id
                }
              },
              EventOrders: {
                path: 'orders/:event_id/:event_type',
                parse: {
                  event_id : event_id => event_id,
                  event_type: event_type => event_type
                }
              },
              EventHedges: {
                path: 'hedges/:event_id/:event_type',
                parse: {
                  event_id : event_id => event_id,
                  event_type: event_type => event_type
                }
              },
              Hedge: {
                path: 'hedge/:hedge_id',
                parse: {
                  hedge_id : hedge_id => hedge_id
                }
              },
              BetMatch: {
                path:'betmatch/:player_filter_id/:order_id?',
                parse:{
                  player_filter_id: player_filter_id => player_filter_id,
                  order_id: order_id => order_id
                }
              },
              PlayerFilters: {
                path:'filters/player'
              },
              ManageFilter: {
                path:'filters/filter/:player_filter_id?',
                parse:{
                  player_filter_id: player_filter_id => player_filter_id
                }
              },
              OrderBook: {
                path: 'book/:event_type/:event_id/:market_id/:participant_id?',
                parse: {
                  event_id : event_id => event_id,
                  event_type: event_type => event_type,
                  market_id: market_id => market_id,
                  participant_id: participant_id => participant_id
                }
              },
              PromotedOrders : {
                path: 'promoted/:order_filter_id',
                parse: {
                  order_filter_id: order_filter_id => order_filter_id
                }
              },
              AdditionalMarkets: {
                path: 'additional/:event_id',
                parse: {
                  event_id: event_id => event_id,
                }
              },
              PlayerMarketDetail: {
                path: 'player/market/:team_event_id/:athlete_id?/:stat?',
                parse: {
                  team_event_id: team_event_id => team_event_id,
                  athlete_id: athlete_id => athlete_id,
                  stat: stat => stat
                }
              },
              OrderActivity: {
                path: 'order/activity/:order_id',
                parse: {
                  order_id: (order_id:string) => order_id
                }
              },
              
              TradeActivity: {
                path: 'order/history/:order_id/:be_type/:position_id?',
                parse: {
                  order_id : order_id => order_id,
                  be_type: be_type => be_type,
                  position_id: position_id => position_id
                }
              },
              League: {
                path: 'league/:league_id',
                parse: {
                  league_id: league_id => league_id
                }
              },
              Team: {
                path: 'team/:team_id',
                parse: {
                  team_id: team_id => team_id
                }
              },
              UFC: {
                path: 'ind/sport/mma'
              },
              UFCSeason: {
                path: 'ind/sport/mma/event/:season_id',
                parse: {
                  season_id: season_id => season_id 
                } 
              },
              HORSE: {
                path: 'ind/sport/horseracing'
              },
              PGA: {
                path: 'ind/sport/golf'
              },
              GolfTournament: {
                path: 'sport/golf/tournament/:tournament_id/:year',
                parse: {
                  tournament_id: tournament_id => tournament_id,
                  year: year => year
                }
              },
              GolfTournamentPlayer: {
                path: 'ind/sport/golf/tournament/:tournament_id/golfer/:golfer_id',
                parse: {
                  tournament_id: tournament_id => tournament_id,
                  golfer_id: golfer_id => golfer_id
                }
              },
              FutureGroupDetails: {
                path: 'future/:future_bid_group_id',
                parse : {
                  future_bid_group_id: future_bid_group_id => future_bid_group_id
                }
              },
              FutureGroupOption: {
                path: 'future/:future_bid_group_id/:future_bid_group_option_id',
                parse: {
                  future_bid_group_id: future_bid_group_id => future_bid_group_id,
                  future_bid_group_option_id: future_bid_group_option_id => future_bid_group_option_id
                }
              },
              FutureBid:{
                path: 'futureLimitOrder/:future_bid_group_option_id'
              },
              FutureBid2:{
                path: 'addQuantity/:futureLimitOrder'
              },
              FutureBid3:{
                path: 'addExpiration/:futureLimitOrders'
              },
              FutureBidReview:{
                path: 'review/:futureLimitOrders'
              },
              ModifyFutureBid:{
                path: 'futureOrder/:future_bid_id'
              },
              FutureOrderLifeCycle: {
                path: 'futureOrderLifeCycle/:item_id/:type',
                parse: {
                  item_id : item_id => item_id,
                  team_event_id: team_event_id => team_event_id
                }
              },
            }
          },

          CompetitionStack: {
            path: 'competition',
            initialRouteName: 'CompetitionHome',
            screens: {
              CompetitionHome: {
                path: 'home'
              },
              CompetitionSelect: {
                path: 'join'
              },
              CompetitionPlay : {
                path: 'play/:competition_id/:mode?',
                parse: {
                  competition_id: competition_id => competition_id,
                  mode: mode => mode
                }
              },
              CompetitionSeason : {
                path: 'season/:competition_season_id/:mode?',
                parse: {
                  competition_season_id: competition_season_id => competition_season_id,
                  mode: mode => mode
                }
              },
              BracketPlay:{
                path: 'brackets/play/:bracket_competition_id?/:bracket_id?',
                parse: {
                  bracket_competition_id: bracket_competition_id => bracket_competition_id,
                  bracket_id: bracket_id => bracket_id
                }
              },
              SquaresPlay: {
                path: 'squares/play/:sq_comp_id',
                parse: {
                  sq_comp_id: sq_comp_id => sq_comp_id
                }
              },
              CompetitionCreate: {
                path:'create/settings/:competition_id?',
                parse: {
                  competition_id:competition_id => competition_id
                }
              },
              CompetitionPick: {
                path: 'play/:competition_id/pick',
                parse:{
                  competition_id:competition_id => competition_id
                }
              },
              CompetitionLeaderboard: {
                path: 'leaderboard/:competition_id',
                parse: {
                  competition_id: competition_id => competition_id
                }
              },
              
              CompetitionLeaderPicks: {
                path: 'play/compare/:competition_id/:player_id',
                parse: {
                  competition_id:competition_id => competition_id,
                  player_id:player_id => player_id
                }
              }
            }
          },
          DiscoverStack : {
            path: 'discover',
            initialRouteName: 'DiscoverHome',
            screens: {
              Discover: {
                path: 'home'
              },
              Store: {
                path: 'store/:catalog_id',
                parse: {
                  catalog_id: catalog_id => catalog_id
                }
              },
              Leaderboard: {
                path: 'leaderboard/:category_id/:timerange_id',
                parse: {
                  category_id: category_id => category_id,
                  timerange_id: timerange_id => timerange_id
                }
              },
              Search : {
                path: 'search'
              }
            }
          },
          SocialStack : {
            path: 'social',
            initialRouteName: 'ActivityFeed',
            screens: {
              ActivityFeed: {
                path: 'activity/:referral_code?',
                parse:{
                  referral_code: referral_code => referral_code,
                }
              },
              NotificationRouter: {
                path: 'notify/:notification_id?',
                parse:{
                  notification_id: notification_id => notification_id
                }
              },
              ActivityDetail: {
                path: 'activity/detail/:post_id/:post_type/:post_comment_id?',
                parse: {
                  post_id: post_id => post_id,
                  post_type: post_type => post_type,
                  post_comment_id:post_comment_id => post_comment_id
                }
              },
              SocialProfile: {
                path: 'socialProfile/:player_id/:init_tab?',
                parse: {
                  player_id: player_id => player_id,
                  init_tab: init_tab => init_tab
                }
              },
              CompanyProfile: {
                path: 'company/:company_id/:init_tab?',
                parse: {
                  company_id: company_id => company_id,
                  init_tab: init_tab => init_tab
                }
              },
              Shareable: {
                path: 'share/:order_id?',
                parse: {
                  order_id: order_id => order_id
                }
              },
              PlayerLeaders :{
                path: '/leaders/:player_id',
                parse: {
                  player_id: player_id => player_id
                }
              },
              Podcasts : {
                path: 'podcasts'
              },
              ArticleFeeds : {
                path: 'feeds'
              },
              Articles : {
                path: 'feeds/articles/:article_feed_id',
                parse: {
                  article_feed_id: article_feed_id => article_feed_id
                }
              },
              PodcastEpisodes: {
                path: 'podcasts/podcast/:podcast_id/:podcast_episode_id?',
                parse: {
                  podcast_id : podcast_id => podcast_id,
                  podcast_episode_id: podcast_episode_id => podcast_episode_id
                }
              },
              PlayerFollowers: {
                path: 'connections/:player_id/:status',
                parse: {
                  player_id: player_id => player_id,
                  status: status => status
                }
              },
              Discover: {
                path: 'discover'
              },
              UpdateProfile: {
                path: 'updateProfile/:tab?',
                parse: {
                  tab: tab => tab
                }
              },
              SearchPlayer: {
                path: 'searchPlayer'
              },
              Followers: {
                path:'followers/:player_id/:type',
                parse: {
                  player_id: player_id => player_id,
                  type: type => type
                }
              },
              Tags: {
                path: 'tags',
              },
              Messages: {
                path: 'messages'
              },
              DirectMessage: {
                path: 'chat/:other_id',
                parse: {
                  other_id: other_id => other_id
                }
              },
              H2H: {
                path: 'h2h/:player_id',
                parse: {
                  player_id: player_id => player_id
                }
              },
              GroupMessage: {
                path: 'groupChat/:group_id',
                parse: {
                  group_id: group_id => group_id
                }
              },
              MemoPost: {
                path:'activity/post/:type/:post_id?/:shared_post_id?',
                parse: {
                  type: type => type,
                  post_id: post_id => post_id,
                  shared_post_id: shared_post_id => shared_post_id
                }
              }
            }
          }
        }
      }
    }
  }
};



